// Breach Step 3: Root Cause
import React from 'react';
import { Card, CardContent } from '../../../../components/ui/card';
import { ROOT_CAUSE_CATEGORIES } from '../constants';
import { TabCheckboxGroup } from '../../../../components/workflow';

export default function Step3RootCause({ formData, updateField }) {
  return (
    <div className="space-y-6">
      <div><h2 className="text-2xl font-bold">Root Cause</h2><p className="text-muted-foreground mt-1">Identify the root cause(s). Select all that apply.</p></div>
      <Card><CardContent className="pt-6">
        <TabCheckboxGroup categories={ROOT_CAUSE_CATEGORIES} selected={formData.root_causes} onChange={v => updateField('root_causes', v)} />
      </CardContent></Card>
    </div>
  );
}
